<template>
  <div>
    <section>
      <div style="background-color: #000; width: 100%;">
        <player lang="es"></player>
      </div>
    </section>
    <section :style="{ backgroundImage: 'url(' + require('@/assets/background_azul.png') + ')'}">
      <div class="container">
        <div class="row pt-4 pb-4">
          <div class="col-md-6 offset-md-6 col-sm-12">
            <br>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Player from "@/components/Player.vue";

export default {
  props: {
    lang: {
      type: String,
      default: 'es'
    },        
  },
  name: "eventoes",
  data() {
    return {
      count: 0,
      optLang: null
    };
  },
  components: {
    Player,
  }
};
</script>
<style scoped>
h5 {
  color: #fff;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
}
</style>